import React from 'react'

import { connect } from "react-redux"
import { withRouter, Link } from 'react-router'
import { browserHistory } from 'react-router'

import * as types from '../../constants/ActionTypes';
import { fetchPracticePatients, practiceSavePatient, practiceDeletePatient } from "../../actions/practiceAdmin"
import { adminUpdatePatient } from '../../actions/admin'
import { fetchPractice } from "../../actions/index"
import { emailParentAssignPatient } from "../../actions/parent"
import UserRow from '../user/UserRow'
import PracticeHeader from '../practice/PracticeHeader'

import EditImg from '../../images/icons/edit.svg';


//import styles
//import './styles/Practice.scss';


@connect((store) => {
	return {
		User: store.User.User,
		users: store.users,
		app: store.app,
		patients: store.patients,
		therapists: store.therapists
	}
})
class PracticeAdminPatient extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			'patient': {},
			'parents': [],
			'therapists': [],
			'guardians': [],
			'showPatientNameEditable': false,
			'showParents': false,
			'showTherapists': false,
			'showGuardians': false,
			'pendingUsersById': {},
			'email_address': ''
		}
		this.ownerAuth = this.ownerAuth.bind(this);
		this.getPractice = this.getPractice.bind(this)
		this.getPatient = this.getPatient.bind(this)
		this.patient = this.patient.bind(this)
		this.showParent = this.showParent.bind(this);
		this.showParents = this.showParents.bind(this);
		this.assignParent = this.assignParent.bind(this)
		this.removeParent = this.removeParent.bind(this)
		this.showTherapist = this.showTherapist.bind(this)
		this.showTherapists = this.showTherapists.bind(this)
		this.availableTherapists = this.availableTherapists.bind(this)
		this.showGuardians = this.showGuardians.bind(this)
		this.availableGuardians = this.availableGuardians.bind(this)
		this.removePatient = this.removePatient.bind(this)
		this.removeTherapist = this.removeTherapist.bind(this)
		this.handleInputChange = this.handleInputChange.bind(this)
		this.updatePatientName = this.updatePatientName.bind(this)
		this.updateShowPatientNameEditableToggle = this.updateShowPatientNameEditableToggle.bind(this)
	}

	getPatient() {
		this.props.dispatch(
			fetchPracticePatients(this.props.app.practice._id, this.props.params.patientId));
	}

	removePatient() {
		const { dispatch, params } = this.props;
		if (confirm(`Really delete ${this.patient().firstName}? This can't be undone`))
			dispatch(practiceDeletePatient(this.props.app.practice._id, params.patientId))
				.then(() => {
					browserHistory.goBack()
				})

	}

	patient() {
		this.state.patient = this.props.patients.length ? this.props.patients[0] : { 'therapists': [] };
		const { patient } = this.state;
		return patient;
	}

	parent() {
		return this.patient().parent || { 'name': 'Unassigned' }
	}

	// patients guardians
	guardians() {
		if (!this.props.app.practice.pendingUsers) return []
		return this.patient().guardians ? this.patient().guardians.map(guardianId => {
			return this.props.app.practice.pendingUsers.find(u => u._id === guardianId) || {}
		}) : [];
	}

	// patients therapists
	therapists() {
		if (!this.props.app.practice.therapists) return []
		return this.patient().therapists ? this.patient().therapists.map(therapistId => {
			return this.props.app.practice.therapists.find(u => u._id === therapistId)
		}) : [];
	}

	assignTherapist(userId) {
		this.props.dispatch(practiceSavePatient(this.props.app.practice._id, {
			'_id': this.patient()._id,
			'therapists': [...new Set(this.patient().therapists.concat([userId]))] // concat unique
		}));

		this.showTherapists()
	}

	assignGuardian(userId) {
		this.props.dispatch(practiceSavePatient(this.props.app.practice._id, {
			'_id': this.patient()._id,
			'guardians': [...new Set(this.patient().guardians.concat([userId]))] // concat unique
		}));

		this.showGuardians()
	}

	assignParent(userId) {
		this.props.dispatch(practiceSavePatient(this.props.app.practice._id, {
			'_id': this.patient()._id,
			'parent': userId
		}));

		// send email to parent
		emailParentAssignPatient(userId, this.patient()._id, this.props.app.practice._id)
		this.showParents()
	}

	removeParent(userId) {
		this.props.dispatch(practiceSavePatient(this.props.app.practice._id, {
			'_id': this.patient()._id,
			'parent': null
		}))
	}

	removeTherapist(userId) {
		this.props.dispatch(practiceSavePatient(this.props.app.practice._id, {
			'_id': this.patient()._id,
			'therapists': this.patient().therapists.filter(u => u !== userId)
		}));
	}

	removeGuardian(userId) {
		this.props.dispatch(practiceSavePatient(this.props.app.practice._id, {
			'_id': this.patient()._id,
			'guardians': this.patient().guardians.filter(u => u !== userId)
		}));
	}

	getPractice() {
		return this.props.dispatch(
			fetchPractice(this.props.params.name)
		)
	}

	showParents() {
		const { parents } = this.props.app.practice;
		const { pendingUsersById } = this.state;
		this.setState({
			'parents': !this.state.showParents ? parents.reduce((acc, pid) => {
				if (!pendingUsersById[pid]) return acc;
				return [...acc, pendingUsersById[pid]]
			}, []) : [],
			'showParents': !this.state.showParents
		})
	}

	showTherapists() {
		const { showTherapists } = this.state;
		this.setState({
			"showTherapists": !showTherapists
		})
	}

	showGuardians() {
		this.setState({
			'showGuardians': !this.state.showGuardians
		})
	}

	componentWillMount() {
		this.props.dispatch({
			type: types.SET_PATIENTS,
			payload: []
		});
		this.props.dispatch({
			type: types.SET_APP_PRACTICE_FIELD,
			payload: {
				key: 'needsData',
				val: true
			}
		});
		this.getPractice()
			.then(() => {
				const { pendingUsers } = this.props.app.practice;
				this.getPatient()
				this.setState({
					"pendingUsersById": pendingUsers.reduce((acc, u) => {
						return { ...acc, [u._id]: u }
					}, {})
				})
			})
	}

	componentWillReceiveProps(nextProps) {
		const { app } = this.props
		if (app.practice._id !== nextProps.app.practice._id
			|| !app.practice.pendingUsers) {
			this.getPractice()
				.then(() => {
					this.getPatient()
				})
		}
	}

	componentDidUpdate() {
		this.ownerAuth()
	}

	showParent(parent) {
		return (
			<ul className="md-list card ">
				<li className="row primary-shade0">
					User
			</li>
				{!parent._id ? (
					<ul className="md-list compact" >
						<li><a className="link" onClick={this.showParents}>Assign a user</a></li>
						{this.state.showParents ? (
							<ul className="md-list compact well">
								{this.availableGuardians().map(user => user && <UserRow
									key={`parent-${user._id}`} user={user}>
									<a className="link" onClick={() => { this.assignParent(user._id) }}>Assign as user</a>
								</UserRow>)}
							</ul>) : null}
					</ul>
				) : null}

				{parent._id ? (
					<li>
						<UserRow user={parent}>
							<p key={`parents-${parent._id}`}>
								Tel: (h) {parent.tel_home} &middot;
							(w) {parent.tel_work} &middot;
							(m) {parent.mobile}
								Email: {parent.email} &middot; <br />
							</p>
						</UserRow>
						<a className="link right md-body-2" onClick={() => { this.removeParent(parent._id) }}>
							Remove
					</a></li>
				) : null}

			</ul>)
	}

	availableTherapists() {
		const { therapists } = this.props.app.practice;
		const patient = this.patient();

		if (!patient || !therapists) return []

		return therapists.filter(therapist => patient.therapists.indexOf(therapist._id) === -1)
	}

	availableGuardians() {
		const patient = this.patient();
		const { parents } = this.props.app.practice;
		const { pendingUsersById } = this.state;
		if (!parents || !patient._id || !Object.keys(pendingUsersById).length) return []

		let a = parents.reduce((acc, pid) => {
			if (!patient.parent) return [...acc, pendingUsersById[pid]]
			if (!pendingUsersById[pid] || pid === patient.parent._id) return acc
			return [...acc, pendingUsersById[pid]];
		}, []);
		return a

	}

	showTherapist(therapists = []) {
		const { patientId } = this.props.params;
		const { app } = this.props;
		return (
			<div><br />

				<br /><br />

				<ul className="md-list marginless card">
					<li className="row primary-shade2 "><a className="link" onClick={this.showTherapists} >+ Therapists</a></li>
					<ul className="md-list compact well" style={{ 'display': this.state.showTherapists ? 'block' : 'none' }}>
						{
							this.availableTherapists()
								.map(user => <UserRow
									key={`therapist-${user._id}`}
									user={user}>
									<a className="link" onClick={() => { this.assignTherapist(user._id) }}>Assign as therapist</a>
								</UserRow>)
						}
						{
							!this.availableTherapists().length && <p className="md-body-1">No available therapists</p>
						}

					</ul>
					{therapists.map(therapist => {

						return therapist && (
							<UserRow key={`therapists-${therapist._id}`} user={therapist}>
								<a className="link right" onClick={() => { this.removeTherapist(therapist._id) }}>
									Remove
								 </a>
								<Link to={`/therapists/practice/${app.practice._id}/patient/${patientId}/${therapist._id}`} >View Sessions</Link>
								<hr />
							</UserRow>
						)
					}
					)}
					{!therapists.length && <li >No therapists assigned</li>}
				</ul>
			</div>
		)
	}

	showGuardian(guardians = []) {
		return <div><br />

			<br /><br />

			<ul className="md-list marginless card">
				<li className="row primary-shade1"><a className="link" onClick={this.showGuardians} >+ Guardians</a></li>
				<ul className="md-list compact well" style={{ 'display': this.state.showGuardians ? 'block' : 'none' }}>
					{this.availableGuardians()
						.map(user => {
							return user && <UserRow
								key={`guardian-${user._id}`}
								user={this.props.app.practice.pendingUsers.find(u => u._id === user._id)}>
								<a className="link" onClick={() => { this.assignGuardian(user._id) }}>Assign as a guardian</a>
							</UserRow>
						})
					}
					{!this.availableGuardians().length && <p className="md-body-1">No available guardians</p>}
				</ul>
				{guardians.map(guardian => {
					if (!guardian) return null
					return (<UserRow key={`guarduans-${guardian._id}`} user={guardian}>
						<a className="link right" onClick={() => { this.removeGuardian(guardian._id) }}>
							Remove
								 </a><br /><hr />
					</UserRow>)

				}
				)}
				{!guardians.length && <li >No guardians assigned</li>}
			</ul>
		</div>
	}

	ownerAuth() {
		const { app, User, params, router } = this.props;
		// is this not an owner of this practice?

		if (!app.authed) return false;

		if (!User.ownPractices
			.find(p => params.name === p.id || params.name === p.slug)) {
			router && router.push('/');
			return false
		}
		return true
	}

	handleInputChange(e, field) {
		if (field === 'firstName') {
			this.state.patient.firstName = e.target.value;
		}
		if (field === 'lastName') {
			this.state.patient.lastName = e.target.value;
		}
		if ( field == 'email_address') {
			this.state.patient.email_address = e.target.value;
		}

		this.setState({
			'patient': this.state.patient
		});
	}

	updatePatientName() {
		const { dispatch } = this.props;
		const patient = this.patient()
		let update = {
			'firstName': patient.firstName,
			'lastName': patient.lastName,
			'email_address': patient.email_address,
		};
		console.log(update);
		dispatch(adminUpdatePatient(patient._id, update));
		this.updateShowPatientNameEditableToggle();
	}

	updateShowPatientNameEditableToggle() {
		const { showPatientNameEditable } = this.state;
		var opened = showPatientNameEditable ? false : true;
		this.setState({
			// toggle value of `opened`
			showPatientNameEditable: opened,
		});
		console.log(this.state.showPatientNameEditable);
	}


	render() {
		this.patient();
		const { patient, showPatientNameEditable } = this.state;

		return <main className="main practice-page practiceAdminPatient">

			<div className="page heigth110 mb8">


				<div ref="content">
					{(patient._id && !patient.therapists.length && !patient.parent) ?
						<div>
							<a className="link right" onClick={this.removePatient}>Delete {patient.firstName} {patient.lastName}</a><br />
						</div> : null}
					{!showPatientNameEditable && (
						<div>
							<div className="patientName">
								<h6>
									{patient.firstName} {patient.lastName}</h6>
								<a className="link right" onClick={() => { this.updateShowPatientNameEditableToggle() }}><img src={EditImg} />
									<small>(Edit profile to add email address)</small>
								</a>
							</div>
							<div className="patientEmail">
								<h6>{patient.email_address}</h6>
							</div>
						</div>
					)}

					{showPatientNameEditable && (
						<div className="patientNameEdit">
							<p>Update patient's name and email</p>
							<input className="md-input md-title"
								autoComplete="off" onChange={(e) => this.handleInputChange(e, "firstName")}
								value={patient.firstName} type="text" placeholder="First Name" />
							<br /><br />

							<input className="md-input md-title" autoComplete="off"
								onChange={(e) => this.handleInputChange(e, "lastName")} value={patient.lastName}
								type="text" placeholder="Last Name" />
							<br /><br />

							<input className="md-input md-title" autoComplete="off"
								onChange={(e) => this.handleInputChange(e, "email_address")} value={patient.email_address}
								type="email" placeholder="Email Address (for parents not signed up)" />
							<br /><br />

							<button className="md-button md-primary right link"
								onClick={() => { this.updatePatientName(patient.firstName, patient.lastName, patient.email_address) }}>Save</button>
						</div>
					)}
					<hr /><br />

					{patient._id && (
						<div >
							{this.showParent(this.parent())}
							{this.showGuardian(this.guardians())}
							{this.showTherapist(this.therapists())}
						</div>
					)}
					{!patient._id && <p>Loading patient...</p>}


					<br />

				</div>
			</div>
		</main>
	}
}

export default withRouter(PracticeAdminPatient);



// WEBPACK FOOTER //
// ./src/components/practice_admin/PracticeAdminPatient.jsx